import * as React from 'react';

import { SchedulerForm, SchedulerFormProps, SchedulerFormStateChangeEvent } from '@progress/kendo-react-scheduler';

import { CustomFormEditor } from './custom-form-editor';
import { CustomDialog } from './custom-dialog';
import { getJobsForSchedulerList, submitEvent } from '../../data/jobData';
import { GridDataItem } from './EventContainerList';
import { JobDataItem } from '../../pages/Diary/Diary';
import dayjs from 'dayjs';

export const FormWithCustomEditor = (props: SchedulerFormProps, getScheduledEvents: () => void) => {
    const [selectedItem, setSelectedItem] = React.useState<GridDataItem | null>(null);
    const [jobDataUnscheduled, setJobDataUnscheduled] = React.useState<JobDataItem[]>([]);
    const [startDate, setStartDate] = React.useState<Date>(new Date(props.dataItem.start.setHours(7, 30)));
    const [endDate, setEndDate] = React.useState<Date | undefined>(props.dataItem.end)
    const [allDay, setAllDay] = React.useState<boolean>(false);


    React.useEffect(() => {
        if(props.dataItem.end){
            setEndDate(new Date(props.dataItem.start.setHours(17, 30)));
        }
    }, [props])


    React.useEffect(() => {
        if(allDay) { 
            setStartDate(new Date(props.dataItem.start.setHours(7, 30)));
            setEndDate(new Date(props.dataItem.end.setHours(16, 30)));
        }
    },[allDay]);

    //Get unscheduled events method
    const getNonScheduledEvents = async () => {
        const nonScheduledData = await getJobsForSchedulerList(false, false);
        setJobDataUnscheduled(nonScheduledData);
    }

    React.useEffect(() => {
        getNonScheduledEvents();
    }, []);


    const requiredValidator = React.useCallback(
        (value: any) => (value === undefined || value === null || value === ''
            ? 'Field is required.'
            : undefined),
        []
    );

    const formValidator = (_dataItem: any, formValueGetter: any) => {
        let result: any = {};

        // result.startDate = [
        //     requiredValidator(formValueGetter('startDate'))
        // ].filter(Boolean).reduce((current, acc) => current || acc, '');

        if(allDay) { 
            result.endDate = undefined
        } else { 
            result.endDate = [
                requiredValidator(formValueGetter('endDate'))
            ].filter(Boolean).reduce((current, acc) => current || acc, '');
        }

        return result;
    };


    const onSubmit = (event: any) => {
        if (selectedItem && endDate) {

            const start = allDay ? dayjs(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : dayjs(startDate).format("YYYY-MM-DD[T]HH:mm:ss[.000Z]") 
            const end = allDay ? dayjs(endDate).format("YYYY-MM-DD") + "T23:00:00.000Z" : dayjs(endDate).format("YYYY-MM-DD[T]HH:mm:ss[.000Z]")

            props.onSubmit(event);
            submitEvent(selectedItem.jobId, start, end, [props.dataItem.employeeIds])
                .then(() => {
                    getScheduledEvents();
                    props.onSubmit(event);
                })
                .catch((error) => {
                    console.log(error);
                })

        }
    }

    const setJob = (item: GridDataItem) => {
        setSelectedItem(item);
    }

    const setStart = (date: Date) => {
        setStartDate(date);
    }

    const setEnd = (date: Date) => {
        setEndDate(date);
    }

    const setAll = (all: boolean) => {
        setAllDay(all);
    }

    return (
        <>
            <SchedulerForm
                {...props}
                onSubmit={onSubmit}
                editor={(props) => CustomFormEditor(props, selectedItem, setJob, jobDataUnscheduled, startDate, endDate, setStart, setEnd, allDay, setAll)}
                dialog={CustomDialog}
                validator={formValidator} 
                />
        </>
    );
};
